import * as React from 'react';
import { DatePicker, IDatePicker, mergeStyleSets, defaultDatePickerStrings } from '@fluentui/react';
import { formatDateToMMDDYYYY } from '../../Utilities/CommonFunction'

const styles = mergeStyleSets({
  root: { selectors: { '> *': { marginBottom: 15 } } },
  control: { marginBottom: 15 },
});

interface IDatePickerFormatProps {
    label: string
    defaultDate: Date | undefined
    getDate: Function
    required: boolean
}

/**
 * DatePicker for mm/dd/yyyy
 * @returns 
 */
const DatePickerFormat = (props: IDatePickerFormatProps) => {
  const [value, setValue] = React.useState<Date | undefined>(props.defaultDate);
  const datePickerRef = React.useRef<IDatePicker>(null);

  const onParseDateFromString = React.useCallback(
    (newValue: string): Date => {
      const previousValue = value || new Date();
      const newValueParts = (newValue || '').trim().split('/');
      const day =
        newValueParts.length > 0 ? Math.max(1, Math.min(31, parseInt(newValueParts[0], 10))) : previousValue.getDate();
      const month =
        newValueParts.length > 1
          ? Math.max(1, Math.min(12, parseInt(newValueParts[1], 10))) - 1
          : previousValue.getMonth();
      let year = newValueParts.length > 2 ? parseInt(newValueParts[2], 10) : previousValue.getFullYear();
      if (year < 100) {
        year += previousValue.getFullYear() - (previousValue.getFullYear() % 100);
      }
      return new Date(year, month, day);
    },
    [value],
  );

  return (
    <div className={styles.root}>
      <DatePicker
        isRequired={props.required}
        componentRef={datePickerRef}
        label={props.label}
        allowTextInput
        ariaLabel="Select a date."
        value={value}
        onSelectDate={(date?: Date) => {
            setValue(date)
            props.getDate(formatDateToMMDDYYYY(date))
        }}
        formatDate={formatDateToMMDDYYYY}
        parseDateFromString={onParseDateFromString}
        className={styles.control}
        strings={defaultDatePickerStrings}
      />
    </div>
  );
};

export default React.memo(DatePickerFormat)